<div cdkDropListGroup class="flex flex-col gap-4">
  @let scopingEnabled = (scopingEnabled$ | async) ?? false;

  @if (!scopingEnabled) {
    <div class="flex justify-between gap-4">
      <ng-container *prIsRegion="[region.Australia]">
        <mat-autocomplete
          #autoSmartGroups="matAutocomplete"
          [autoActiveFirstOption]="true"
          (optionSelected)="addSmartGroup($event.option.value)"
        >
          @for (
            smartGroup of filteredSmartGroups$ | async;
            track smartGroup.uid
          ) {
            <mat-option [value]="smartGroup">
              {{ smartGroup.uid }} - {{ smartGroup.title }}
            </mat-option>
          }
        </mat-autocomplete>
        <pt-search-field icon="add" class="flex-1">
          <input
            #autoComplete="matAutocompleteTrigger"
            matInput
            placeholder="Add a Smart Code"
            [matAutocomplete]="autoSmartGroups"
            [formControl]="smartGroupSelector"
            (click)="autoComplete.openPanel()"
          />
        </pt-search-field>
      </ng-container>
      <button mat-raised-button color="primary" (click)="addGroup()">
        Add New Group
      </button>
    </div>
  }

  @if (treatmentConfig$ | async; as treatmentConfig) {
    @if (treatmentConfig.serviceCodeSmartGroups.length) {
      <div class="service-code-group">
        <div class="header flex items-center">
          <div class="label-spacer"><span>Smart</span></div>
          <span class="mat-caption flex-1"
            >Smart codes will be automatically selected when the treatment is
            charted.</span
          >
        </div>

        @for (
          entry of treatmentConfig.serviceCodeSmartGroups;
          track entry.uid
        ) {
          <div class="service-code">
            <div class="flex items-center gap-4">
              <div class="flex flex-1 flex-col gap-1">
                <span>{{ entry.title }}</span>
                <small class="opacity-50"
                  >Auto-selects between:
                  {{ entry.serviceCodes | map: summariseCodes }}</small
                >
              </div>
              <button
                mat-icon-button
                color="warn"
                (click)="deleteSmartEntry(entry)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }
    @if (scopingEnabled) {
      <pr-information-box theme="info">
        Item codes are matched to the fee schedule on the treatment. Changing a
        treatment's fee schedule swaps its codes over to that schedule's groups.
        Codes from the other schedule are removed, and required codes for the
        new schedule are added.
      </pr-information-box>

      @for (section of sections$ | async; track section.label) {
        <div class="overflow-hidden rounded border border-solid border-slate-300">
          <div
            class="flex items-center justify-between gap-4 border-0 border-b border-solid border-slate-300 bg-slate-100 px-4 py-2"
          >
            <h3 class="!m-0 !text-[15px] !font-medium">{{ section.label }}</h3>
            @if (section.serviceCodeType; as serviceCodeType) {
              <button
                mat-stroked-button
                color="primary"
                (click)="addGroup(serviceCodeType)"
              >
                Add New Group
              </button>
            }
          </div>
          <div class="px-4">
            @if (!section.serviceCodeType) {
              <div class="pt-4">
                <pr-information-box theme="info">
                  These item codes are added to the treatment regardless of the
                  fee schedule it's charted against. Drag each into its ACC or
                  MOH group, then remove the empty group.
                </pr-information-box>
              </div>
            }
            @if (!section.groups.length) {
              <div class="py-4 opacity-50">
                No item code groups for {{ section.label }} yet
              </div>
            }
            <pr-service-groups-editor
              [serviceCodeGroups]="section.groups"
              [acceptsNewCodes]="!!section.serviceCodeType"
              (serviceCodeGroupsChange)="
                updateScopedGroups(section.serviceCodeType, $event)
              "
            />
          </div>
        </div>
      }
    } @else {
      <pr-service-groups-editor
        [serviceCodeGroups]="treatmentConfig.serviceCodeGroups"
        (serviceCodeGroupsChange)="updateGroups($event)"
      />
    }
  }
</div>
